module.exports = __webpack_public_path__ + "static/img/pictureD.0c7dd9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pictureD.jpg
// module id = F0xk
// module chunks = 0